'use client';

import { getEnv } from 'common-nextjs';
import { useMount } from 'react-use';
import { Button } from 'ui';
import ErrorMessage from '~/components/Form/ErrorMessage';
import SimplePage from '~/components/Layout/SimplePage';
import { ERROR_IMAGES, newRandomImage } from '~/constants/imagesAndVideos';
import { fireWebError } from '~/services/analytics/events/generic';
import { getSentry } from '~/services/sentry/wrapper';

export default function AppDirErrorPage({
  error,
  reset,
  title,
}: {
  error: Error & { digest?: string };
  reset: () => void;
  title: string;
}) {
  useMount(() => {
    fireWebError(500);
    getSentry()?.captureException(error, {
      extra: {
        APP_DIR_ERROR_PAGE: true,
      },
    });
  });

  return (
    <SimplePage>
      <h1 className="mb-4 mt-12 text-center text-2xl font-semibold">{title}</h1>

      {error && (
        <div className="mx-auto mb-4 max-w-md">
          <ErrorMessage
            errors={
              getEnv('NODE_ENV') === 'production'
                ? `Something went wrong... (digest ${error.digest})`
                : [error, `digest: ${error.digest}`]
            }
          />
        </div>
      )}

      <div className="text-center">
        <Button onClick={() => reset()} className="mb-8">
          Try again
        </Button>
      </div>

      <div>
        <video
          autoPlay
          muted
          loop
          className="mx-auto"
          src={ERROR_IMAGES[newRandomImage()]}
        />
      </div>
    </SimplePage>
  );
}
